import api from './api'

export const emailTemplateService = {
  getAllTemplates: async () => {
    const response = await api.get('/email-templates')
    return response.data
  },

  getTemplateById: async (id) => {
    const response = await api.get(`/email-templates/${id}`)
    return response.data
  },

  createTemplate: async (data) => {
    const response = await api.post('/email-templates', data)
    return response.data
  },

  updateTemplate: async (id, data) => {
    const response = await api.put(`/email-templates/${id}`, data)
    return response.data
  },

  deleteTemplate: async (id) => {
    const response = await api.delete(`/email-templates/${id}`)
    return response.data
  },

  uploadImage: async (id, file) => {
    const formData = new FormData()
    formData.append('image', file)
    const response = await api.post(`/email-templates/${id}/image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return response.data
  },

  previewTemplate: async (id) => {
    const response = await api.get(`/email-templates/${id}/preview`)
    return response.data
  },

  previewContent: async ({ subject_line, preview_text, html_body }) => {
    const response = await api.post('/email-templates/preview-content', { subject_line, preview_text, html_body })
    return response.data
  },

  testSend: async (id, email) => {
    const response = await api.post(`/email-templates/${id}/test-send`, { email })
    return response.data
  }
}
